import { ref, type Ref } from "vue";
import { localStorageSetPageHeaders } from "@/common/localStorageUtil";
import type { TableHeader } from "../types";

/**
 * composableへ渡す依存をまとめた型。
 */
interface UseTmpMemberTableSettingsParams {
  pageKey: string;
  defaultTableHeaders: Ref<TableHeader[]>;
  tableHeaders: Ref<TableHeader[]>;
  displayListSettingDialog: Ref<boolean>;
}

/**
 * 画面ロジックを扱う composable。
 */
export const useTmpMemberTableSettings = (params: UseTmpMemberTableSettingsParams) => {
  const {
    pageKey,
    defaultTableHeaders,
    tableHeaders,
    displayListSettingDialog,
  } = params;

  const tableHeadersSetting = ref<TableHeader[]>([]);

  const onClickListSetting = (): void => {
    tableHeadersSetting.value = JSON.parse(JSON.stringify(tableHeaders.value)) as TableHeader[];
    displayListSettingDialog.value = true;
  };

  const onClickListSettingCancel = (): void => {
    tableHeadersSetting.value = [];
    displayListSettingDialog.value = false;
  };

  const onClickListSettingReset = (): void => {
    tableHeadersSetting.value = JSON.parse(JSON.stringify(defaultTableHeaders.value)) as TableHeader[];
  };

  const onClickListSettingOk = (): void => {
    tableHeaders.value = tableHeadersSetting.value;
    localStorageSetPageHeaders(pageKey, JSON.stringify(tableHeadersSetting.value));
    tableHeadersSetting.value = [];
    displayListSettingDialog.value = false;
  };

  return {
    tableHeadersSetting,
    onClickListSetting,
    onClickListSettingCancel,
    onClickListSettingReset,
    onClickListSettingOk,
  };
};
